@if (done) {
  <h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{ 'invite.done_title' | translate }}</h4>
  <p class="f-s-14 m-t-8">{{ 'invite.done_text' | translate }}</p>
  <a mat-flat-button color="primary" class="w-100 m-t-16" routerLink="/login">{{ 'invite.go_login' | translate }}</a>
} @else {
  <h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{ 'invite.title' | translate }}</h4>
  <p class="f-s-14 m-t-8">{{ 'invite.subtitle' | translate }}</p>

  <mat-card class="shadow-none bg-light-secondary m-t-12">
    <div class="p-x-16 p-y-12">
      <strong class="f-s-14">{{ 'recovery_password.password_rules' | translate }}</strong>
      <ul class="m-b-0 m-t-8 f-s-14">
        <li>{{ 'recovery_password.rules_1' | translate }}</li>
        <li>{{ 'recovery_password.rules_2' | translate }}</li>
        <li>{{ 'recovery_password.rules_3' | translate }}</li>
        <li>{{ 'recovery_password.rules_4' | translate }}</li>
      </ul>
    </div>
  </mat-card>

  @if (error) {
    <p class="m-t-16 f-s-14 text-error" role="alert">{{ error }}</p>
  }

  <form class="m-t-24" [formGroup]="form" (ngSubmit)="submit()" #inviteForm="ngForm">
    <mat-label class="f-s-14 f-w-600 m-b-6 d-block">{{ 'recovery_password.new_password' | translate }}</mat-label>
    <mat-form-field appearance="outline" class="w-100" color="primary">
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="new_password1" autocomplete="new-password"/>
      <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
              [attr.aria-label]="(hidePassword ? 'login.show_password' : 'login.hide_password') | translate">
        <i-tabler [name]="hidePassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
      </button>
      @if (form.controls.new_password1.hasError('minlength')) {
        <mat-error>{{ 'recovery_password.password_min_length' | translate: {minLength: passwordMinLength} }}</mat-error>
      } @else if (form.controls.new_password1.hasError('passwordStrength')) {
        <mat-error>{{ 'recovery_password.password_strength_error' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-label class="f-s-14 f-w-600 m-b-6 d-block">{{ 'recovery_password.confirm_password' | translate }}</mat-label>
    <mat-form-field appearance="outline" class="w-100" color="primary">
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="new_password2" autocomplete="new-password"/>
    </mat-form-field>
    @if (form.hasError('passwordMismatch') && form.controls.new_password2.dirty) {
      <p class="f-s-14 text-error m-t-0">{{ 'recovery_password.passwords_dont_match' | translate }}</p>
    }

    <button mat-flat-button color="primary" class="w-100 m-t-8" type="submit" [disabled]="form.invalid || saving">
      {{ 'invite.activate' | translate }}
    </button>
  </form>
}
